import React from "react";
import SharedHelmet from "./Helmet";

const TITLE = "À propos de Do Calculate - La plateforme de calculatrices en ligne";
const DESCRIPTION = "Do Calculate est la plus grande plateforme proposant plus de 2 000 calculatrices gratuites en ligne pour vous aider à effectuer des calculs rapides et précis dans divers domaines : finance, santé, mathématiques, physique et bien d'autres.";
const KEYWORDS = "Do Calculate, calculatrice, calculatrice gratuite, mathématiques, finance, santé, physique, calculs en ligne";
const OG_URL = "https://do-calculate.com/fr/about/";

const About = () => {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="p-3 mb-2 bg-success text-white">
        <h1 style={{ fontSize: "24px", marginBottom: "15px" }}>
          <b>À propos de Do Calculate</b>
        </h1>
      </div>
      <p style={{ lineHeight: "1.6" }}>
        Do Calculate est l'une des plus grandes plateformes spécialisées dans la
        mise à disposition de plus de 2 000 calculatrices gratuites en ligne.
        Nous proposons une large gamme d'outils couvrant les mathématiques, la
        finance, la santé, la physique et bien d'autres domaines. Notre
        plateforme a pour objectif de faciliter des calculs rapides et précis
        dans de nombreux domaines, avec des informations détaillées disponibles
        pour chaque calculatrice.
        <br />
        Plus de 92 % de nos calculatrices reposent sur des formules et équations
        reconnues issues de manuels scolaires, comme par exemple la calculatrice
        d'indice de masse corporelle (IMC). Lorsque des formules font l'objet de
        débats, nous présentons les résultats de toutes les formules couramment
        utilisées.
        <br />
        Nous nous concentrons exclusivement sur la fourniture de calculatrices
        en ligne rapides, complètes, pratiques et gratuites dans de nombreux
        domaines. Notre objectif est de devenir la référence pour tous ceux qui
        recherchent des calculs rapides et fiables. De plus, nous croyons que
        l'internet doit être une source d'informations gratuites, c'est pourquoi
        tous nos outils et services sont entièrement gratuits et ne nécessitent
        aucune inscription.
        <br />
        Nous avons fait des efforts considérables pour nous assurer que toutes
        les calculatrices fonctionnent correctement. Cependant, si vous
        constatez une erreur ou avez des suggestions pour améliorer nos
        services, n'hésitez pas à nous contacter.
      </p>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        <p style={{ lineHeight: "1.6" }}>
          Si vous avez des questions, souhaitez demander l'ajout de nouvelles
          calculatrices, ou signaler un problème avec l'une d'elles, contactez-nous
          à l'adresse suivante :
          <br />
          <a
            href="mailto:info@do-calculate.com"
            style={{ color: "white", textDecoration: "underline" }}
          >
            info@do-calculate.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default About;
